// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2ghG3","topBottomGutter":"Layout_topBottomGutter__29lIT"};